export const jackpotsController = {
  initial: 'controllerIdle',
  states: {
    controllerIdle: {
      on: {
        LAYOUT_CHANGE_END: [
          {
            target: 'fetchJackpotFeeds',
            cond: 'isJackpotsControllerEnabled',
          },
        ],
      },
    },
    fetchJackpotFeeds: {
      invoke: {
        src: 'fetchJackpotFeeds',
        onDone: [
          {
            actions: ['updateJackpotFeeds'],
            target: 'renderComponent',
          },
        ],
      },
    },
    renderComponent: {
      invoke: {
        src: 'prepareJackpotsContent',
        onDone: {
          actions: [
            {
              type: 'batchLayoutOperations',
              data: '$event.data.updates',
              meta: {
                selectors: ['$action.data'],
              },
            },
          ],
          target: 'watchJackpotsFeed',
        },
      },
    },
    watchJackpotsFeed: {
      invoke: [{ src: 'watchJackpotsFeed' }],
      on: {
        JACKPOT_FEEDS_UPDATED: {
          actions: ['updateJackpotFeeds', 'jackpotsFeedComponents_reload'],
        },
        LAYOUT_CHANGE_END: [
          {
            target: 'fetchJackpotFeeds',
            cond: 'isJackpotsControllerEnabled',
          },
          {
            target: 'controllerIdle',
          },
        ],
      },
    },
  },
};
